module.exports = __webpack_public_path__ + "static/media/shop-time.4cb14bbd.svg";